
import React from 'react';
import { PricingCard } from './PricingCard';
import { PricingPlan } from '../types/pricingTypes';
import { useToast } from '@/hooks/use-toast';
import { useNavigate } from 'react-router-dom';

interface PricingGridProps {
  plans: PricingPlan[];
  onSubscribe: () => Promise<void>;
  isLoading: boolean;
  isLoggedIn: boolean;
  isSubscribed?: boolean;
}

export const PricingGrid = ({ plans, onSubscribe, isLoading, isLoggedIn, isSubscribed = false }: PricingGridProps) => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleSubscribeClick = async (plan: PricingPlan) => {
    // If it's the Pro plan and user is already subscribed, show message
    if (plan.name === "Pro" && isSubscribed) {
      toast({
        title: "Already Subscribed",
        description: "You already have an active Pro subscription",
        variant: "default",
      });
      return;
    }

    // If it's the free plan and user is already logged in, do nothing
    if (plan.name === "Free" && isLoggedIn) {
      return;
    }

    // If user is not logged in, redirect to auth page
    if (!isLoggedIn) {
      toast({
        title: "Login Required",
        description: "Please log in to subscribe to a plan",
        variant: "destructive",
      });
      navigate('/auth');
      return;
    }
    
    // For pro plan, proceed with subscription
    if (plan.name === "Pro") {
      await onSubscribe();
    }
  };

  return (
    <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
      {plans.map((plan) => (
        <PricingCard
          key={plan.name}
          plan={plan}
          onSubscribe={() => handleSubscribeClick(plan)}
          isLoading={isLoading && plan.name === "Pro"}
          disabled={plan.disabled || false}
        />
      ))}
    </div>
  );
};
